export default "__VITE_ASSET__DVPthJxo__"